import React from "react";
import ManageOrder from "../../components/ManageOrder";
import { ORDER_TYPE } from "../../enums/order.enum";

const ManageConsultationOrder = () => {
  return <ManageOrder orderType={ORDER_TYPE.CONSULTATION} />;
};

export default ManageConsultationOrder;
